export const Severity_00 = 'severityFactor-00';
export const Severity_10 = 'severityFactor-10';
export const Severity_20 = 'severityFactor-20';
export const SeverityValues = [Severity_00, Severity_10, Severity_20];
//# sourceMappingURL=types.js.map